import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectTypeEntityModel} from "../custom-object-type-entity.model";
import {MembershipTypeCustomObjectTypeSearchModel} from "../membership-type-custom-object-type-search.model";
import {CustomObjectTypeSearchPageComponent} from "./custom-object-type-search-page.component";

@Component({
    selector: "wbo-membership-type-custom-object-type-search-page",
    templateUrl: "./custom-object-type-search-page.component.html",
    providers: [provideSearchModel(MembershipTypeCustomObjectTypeSearchModel), provideEntityModel(CustomObjectTypeEntityModel)]
})
export class MembershipTypeCustomObjectTypeSearchPageComponent extends CustomObjectTypeSearchPageComponent {
}
